// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../../firebase';
// import DOMPurify from 'dompurify';
// import link from '../../main_assets/link.PNG';
// import './work.css';
// import BlurhashImg from '../../@/components/Image/BlurhashImg';

// const Work = () => {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
//   const [isHovering, setIsHovering] = useState(false);
//   const containerRef = useRef(null);

//   // Track mouse position when hovering over a project card
//   const handleMouseMove = (e) => {
//     if (containerRef.current) {
//       const rect = containerRef.current.getBoundingClientRect();
//       setCursorPosition({
//         x: e.clientX - rect.left,
//         y: e.clientY - rect.top
//       });
//     }
//   };

//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const projectsCollection = collection(db, 'projects');
//         const snapshot = await getDocs(projectsCollection);
//         const fetchedProjects = snapshot.docs.map(doc => {
//           const data = doc.data();
//           console.log(`Project ${doc.id} data:`, data);
//           console.log(`Project ${doc.id} cover image:`, data.coverImage);

//           if (!data.coverImage) {
//             console.warn(`Project ${doc.id} is missing a cover image.`);
//           }

//           if (!data.slug) {
//             console.warn(`Project ${doc.id} is missing a slug.`);
//           }

//           return { id: doc.id, ...data };
//         });

//         fetchedProjects.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0));

//         console.log('Fetched projects:', fetchedProjects);
//         setProjects(fetchedProjects);
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//         setError("Failed to load projects. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchProjects();
//   }, []);

//   if (loading) {
//     return <div>Loading projects...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   const visibleProjects = projects.filter(project => project.isVisible);
//   const featuredProject = visibleProjects[0];

//   const getProjectLink = (project) => {
//     return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
//   };

//   return (
//     <>
//     <div 
//       className="works-container section__padding"
//       ref={containerRef}
//     >
//       {isHovering && (
//         <div 
//           className="custom-cursor" 
//           style={{ 
//             left: `${cursorPosition.x}px`, 
//             top: `${cursorPosition.y}px`
//           }}
//         >
//           <span>View Work</span>
//         </div>
//       )}

//       {featuredProject && (
//         <Link 
//           to={getProjectLink(featuredProject)} 
//           className="work-card"
//           onMouseEnter={() => setIsHovering(true)}
//           onMouseLeave={() => setIsHovering(false)}
//           onMouseMove={handleMouseMove}
//         >
//           <div className="featured-image">
//             <BlurhashImg src={featuredProject.coverImage} placeholderColor="#888"/>
//             <div className="overlayp">
//               <h2>{featuredProject.title}</h2>
//               <p>{featuredProject.description}</p>
//               <p>{featuredProject.location}</p>
//             </div>
//           </div>
//         </Link>
//       )}

//       <h1>Projects</h1>
//       <p>We build brands that cannot be ignored.</p>

//       <div className="work-cards">
//         {visibleProjects.slice(1).map((project) => (
//           <Link 
//             key={project.id} 
//             to={getProjectLink(project)} 
//             className="work-card"
//             onMouseEnter={() => setIsHovering(true)}
//             onMouseLeave={() => setIsHovering(false)}
//             onMouseMove={handleMouseMove}
//           >
//             <div className="featured-image">
//               {project.coverImage ? (
//                 <BlurhashImg 
//                   src={project.coverImage} 
//                   placeholderColor="#888"
//                   onError={(e) => {
//                     console.error('Error loading image:', project.coverImage);
//                     e.target.src = '/fallback-image.jpg'; 
//                   }}
//                 />
//               ) : (
//                 <div className="no-image">No Image Available</div>
//               )}
//               <div className="overlayp">
//                 <h2>{project.title || 'Untitled Project'}</h2>
//                 <p>{project.description || 'not specified'}</p>
//                 <p>{project.location || 'Location not specified'}</p>
//               </div>
//             </div>
//           </Link>
//         ))}
//       </div>
//     </div>
//     <div className="ulev__footer-icotext section__padding">
//       <button style={{ display: 'flex', alignItems: 'center', marginRight: 'auto', background: 'none', border: 'none' }}>
//         <p className='reach' style={{ marginRight: '10px', color: "#888" }}>Connect with us</p>
//       </button>

//       <button className='cont' style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginTop: '25px', cursor: 'pointer', background: 'none', border: 'none' }}>
//         <span style={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
//           <img src={link} alt="linked" />
//         </span>
//       </button>
//     </div>
//   </>
//   );
// };

// export default Work;






import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import DOMPurify from 'dompurify';
import link from '../../main_assets/link.PNG';
import './work.css';
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import emailjs from '@emailjs/browser';

const Work = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const containerRef = useRef(null);
  
  // Contact form state
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailStatus, setEmailStatus] = useState('');
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    time: new Date().toLocaleString() 
  });

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init("ISG04P_c0uObH1Og8");
  }, []);

  const toggleEmailForm = () => {
    setShowEmailForm(prev => !prev);
    if (!showEmailForm) {
      document.body.classList.add('popup-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('popup-open');
      document.body.style.overflow = 'auto';
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      time: new Date().toLocaleString() 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailStatus('sending');
    
    const templateParams = {
      from_name: formData.name,
      email: formData.email,
      to_email: "marcel.ulevus@gmail.com",
      reply_to: formData.email,
      company: formData.company,
      message: formData.message,
      time: formData.time,
      to_name: "Ulevus Team",
      subject: `New contact from ${formData.name}${formData.company ? ` at ${formData.company}` : ''}`
    };
    
    const serviceId = 'service_yf0fnk1';
    const templateId = 'template_azclhrj';
    
    emailjs.send(serviceId, templateId, templateParams)
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setEmailStatus('success');
        setFormData({
          name: '',
          email: '',
          company: '',
          message: '',
          time: new Date().toLocaleString()
        });
        setTimeout(() => {
          setEmailStatus('');
        }, 3000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        setEmailStatus('error');
      });
  };

  // Track mouse position when hovering over a project card
  const handleMouseMove = (e) => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setCursorPosition({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      });
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsCollection = collection(db, 'projects');
        const snapshot = await getDocs(projectsCollection);
        const fetchedProjects = snapshot.docs.map(doc => {
          const data = doc.data();
          console.log(`Project ${doc.id} data:`, data);
          console.log(`Project ${doc.id} cover image:`, data.coverImage);

          if (!data.coverImage) {
            console.warn(`Project ${doc.id} is missing a cover image.`);
          }

          if (!data.slug) {
            console.warn(`Project ${doc.id} is missing a slug.`);
          }

          return { id: doc.id, ...data };
        });

        fetchedProjects.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0));

        console.log('Fetched projects:', fetchedProjects);
        setProjects(fetchedProjects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setError("Failed to load projects. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  if (loading) {
    return <div>Loading projects...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const visibleProjects = projects.filter(project => project.isVisible);
  const featuredProject = visibleProjects[0];

  const getProjectLink = (project) => {
    return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
  };

  return (
    <>
      <div 
        className="works-container section__padding"
        ref={containerRef}
      >
        {isHovering && (
          <div 
            className="custom-cursor" 
            style={{ 
              left: `${cursorPosition.x}px`, 
              top: `${cursorPosition.y}px`
            }}
          >
            <span>View Work</span>
          </div>
        )}

        {featuredProject && (
          <Link 
            to={getProjectLink(featuredProject)} 
            className="work-card"
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onMouseMove={handleMouseMove}
          >
            <div className="featured-image">
              <BlurhashImg src={featuredProject.coverImage} placeholderColor="#888"/>
              <div className="overlayp">
                <h2>{featuredProject.title}</h2>
                <p>{featuredProject.description}</p>
                <p>{featuredProject.location}</p>
              </div>
            </div>
          </Link>
        )}

        <h1>Projects</h1>
        <p>We build brands that cannot be ignored.</p>

        <div className="work-cards">
          {visibleProjects.slice(1).map((project) => (
            <Link 
              key={project.id} 
              to={getProjectLink(project)} 
              className="work-card"
              onMouseEnter={() => setIsHovering(true)}
              onMouseLeave={() => setIsHovering(false)}
              onMouseMove={handleMouseMove}
            >
              <div className="featured-image">
                {project.coverImage ? (
                  <BlurhashImg 
                    src={project.coverImage} 
                    placeholderColor="#888"
                    onError={(e) => {
                      console.error('Error loading image:', project.coverImage);
                      e.target.src = '/fallback-image.jpg'; 
                    }}
                  />
                ) : (
                  <div className="no-image">No Image Available</div>
                )}
                <div className="overlayp">
                  <h2>{project.title || 'Untitled Project'}</h2>
                  <p>{project.description || 'not specified'}</p>
                  <p>{project.location || 'Location not specified'}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      
      <div className="ulev__footer-icotext section__padding">
        <button 
          onClick={toggleEmailForm}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginRight: 'auto', 
            background: 'none', 
            border: 'none',
            cursor: 'pointer'
          }}
        >
          <p className='reach' style={{ marginRight: '10px', color: "#888" }}>Connect with us</p>
        </button>

        <button 
          className='cont' 
          onClick={toggleEmailForm}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginLeft: 'auto', 
            marginTop: '25px', 
            cursor: 'pointer', 
            background: 'none', 
            border: 'none' 
          }}
        >
          <span style={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
            <img src={link} alt="linked" />
          </span>
        </button>
      </div>

      {/* Contact Form Modal */}
      {showEmailForm && (
        <div className="email-modal-overlay" onClick={toggleEmailForm}>
          <div className="email-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send us a message</h3>
              <button 
                className="close-button"
                onClick={toggleEmailForm}
                type="button"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            
            {emailStatus === 'success' ? (
              <div className="email-success">
                <p>Your message has been sent successfully!</p>
                <button 
                  className="close-button-success" 
                  onClick={toggleEmailForm}
                  type="button"
                >
                  Close
                </button>
              </div>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} className="dark-form">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your email address"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="styled-input"
                    placeholder="Your company"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Tell us about your project</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    className="styled-textarea"
                    placeholder="Describe your project or inquiry"
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="submit-button minimal-submit"
                  disabled={emailStatus === 'sending'}
                >
                  {emailStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>
                
                {emailStatus === 'error' && (
                  <p className="error-message">
                    Failed to send message. Please try again or contact us directly at info@ulevus.com
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Work;